import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss']
})
export class HomepageComponent implements OnInit {

  public homepageTitle: string = "POSF - Platforma online de schimbare a furnizorului de energie electrică și gaze naturale la nivel național";
  public homepageText = "Prin realizarea Platformei online de schimbare a furnizorului de energie electrică și gaze naturale la nivel național (POSF) se optimizează procesele operaționale din piața de energie generate de solicitările de schimbare a furnizorului prin gestionarea fluxul de informații în mod complet automatizat și implementarea unui cadru de lucru accesibil participanților la piața de energie electrică și gaze naturale.";
  public naturalGasSupplyComparison: string = "Comparator oferte-tip de furnizare a gazelor naturale";
  public naturalElectricitySupplyComparison: string = "Comparator oferte-tip de furnizare a energiei electrice";

  constructor() { }

  ngOnInit(): void {
  }

}
